module.exports = __webpack_public_path__ + "static/criminal-mtg_clb-2818419f5804b5ee08254a6b3be54650.jpg";